import React from "react";
import { ErrorBoundary } from "tsi-common-react/src/components/ErrorBoundary/index";

// Client-only loader for the checkout app. The checkout lives inside the React
// document (rendered by CheckoutDocumentTemplate) rather than mounted via a
// separate createRoot/dynamicPlaceComponent, but its dependency tree is not
// SSR-safe, so it is lazy-imported and gated to client-only paint: the server
// and the first hydration render both produce null (no mismatch), and the real
// checkout mounts after hydration and loads its data client-side.
const CheckoutAppInner = React.lazy(() => import("./CheckoutAppInner"));

// The ErrorBoundary wraps Suspense (not just the inner app) so it catches both
// a lazy chunk-load failure -- which throws at the Suspense site -- and any
// render error from the checkout. The checkout renders inside the document's
// single React root, so an uncaught failure here would otherwise blank the
// whole document; the boundary keeps the blast radius scoped to #checkout-app.
export const CheckoutApp = (): React.ReactNode => {
    const [isHydrated, setIsHydrated] = React.useState(false);
    React.useEffect(() => setIsHydrated(true), []);
    if (!isHydrated) {
        return null;
    }
    return (
        <ErrorBoundary>
            <React.Suspense fallback={null}>
                <CheckoutAppInner />
            </React.Suspense>
        </ErrorBoundary>
    );
};
